export enum WidgetTagOptionType {
    All = -1,
    AllSelected = 1,
    AnySelected = 2,
    AnyRelated = 3,
    AllRelated = 4,
}

export interface IWidgetTagOptionTypesItem {
    Id: WidgetTagOptionType;
    TextId: string;
    StartPage?: boolean;
}

export const WidgetTagOptionTypes: IWidgetTagOptionTypesItem[] = [
    { Id: WidgetTagOptionType.All, TextId: 'ccmAppearance.listView.allTags' },
    { Id: WidgetTagOptionType.AllSelected, TextId: 'widget.all_selected' },
    { Id: WidgetTagOptionType.AnySelected, TextId: 'widget.any_selected' },
    { Id: WidgetTagOptionType.AllRelated, TextId: 'widget.tags.all_related', StartPage: false },
    { Id: WidgetTagOptionType.AnyRelated, TextId: 'widget.tags.any_related', StartPage: false },
];
